import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faExclamationTriangle, faTrash, faX, faPlusCircle, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '../Css/Animation.css';
import {Loader , Spinner} from '../Loader/Loader';
import { useNavigate } from 'react-router-dom';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages'
import { validate } from '../CommenResponseAndErrorHandlers/commenUiErrorHandlers';
import { decryptData } from '../../utils/storageCrypto';
import useCommonResponseHandler from '../CommenResponseAndErrorHandlers/CommenResponseHandler';

//import Dropdown from './DropDown'
// Custom hook to handle outside clicks
const useOutsideClick = (ref, callback) => {
  React.useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [ref, callback]);
};

const CustomDropdown = ({ options = [], selected, onSelect, labelField, valueField, placeholder, onAddNew }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [focusedOptionIndex, setFocusedOptionIndex] = useState(null);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);


  useOutsideClick(dropdownRef, () => setIsOpen(false));

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
        searchInputRef.current.focus();
    }
}, [isOpen]);

  // Filter options based on the search term
  const filteredOptions = options.filter(option => {
    const label = option[labelField] || '';
    return label.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleOptionClick = (name, id) => {
    onSelect(name, id);
    setIsOpen(false);
    setFocusedOptionIndex(null);
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (!isOpen) {
          setIsOpen(true);
        }
        setFocusedOptionIndex(prevIndex => {
          const newIndex = prevIndex === null ? 0 : Math.min(prevIndex + 1, filteredOptions.length - 1);
          scrollToOption(newIndex);
          return newIndex;
        });
         break;
      case 'ArrowUp':
        e.preventDefault();
        if (!isOpen) {
          setIsOpen(true);
        }
        setFocusedOptionIndex(prevIndex => {
          const newIndex = prevIndex === null ? filteredOptions.length - 1 : Math.max(prevIndex - 1, 0);
          scrollToOption(newIndex);
          return newIndex;
        });
        break;
      case 'Enter':
        e.preventDefault();
        if (focusedOptionIndex !== null) {
          const selectedOption = filteredOptions[focusedOptionIndex];
          handleOptionClick(selectedOption[labelField], selectedOption[valueField]);
        }
        break;
      default:
        break;
    }
  };
  const scrollToOption = (index) => {
    const optionElements = dropdownRef.current.querySelectorAll('div[data-index]');
    if (optionElements && optionElements[index]) {
      optionElements[index].scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }
  };


  return (
    <div className="relative w-1/3" ref={dropdownRef}>
      <div
        className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`text-sm ${selected ? 'text-black' : 'text-[#838195]'}`}>
          {selected || placeholder}
        </span>
        <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />
      </div>
      {isOpen && (
       <div className="absolute mt-1 w-full max-h-40 bg-white border border-gray-300 rounded-md shadow-md z-10 flex flex-col">
          <input
            type="text"
            className="p-1 border rounded-md border-blue-500 focus:outline-none hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus={isOpen}

          />
          <div className="overflow-y-auto scrollbar-visible flex-grow">
          {filteredOptions.length ? (
            filteredOptions.map((option, index) => (
              <div
                key={option[valueField]}
                data-index={index}
                className={`p-2 cursor-pointer text-sm ${index === focusedOptionIndex ? 'bg-blue-500 text-white' : ''} hover:bg-blue-500 hover:text-white`}
                onClick={() => handleOptionClick(option[labelField], option[valueField])}
              >
                {option[labelField]}
              </div>
            ))
          ) : (
            <div className="p-2 text-gray-500">No results found</div>
          )}
          </div>
          {onAddNew && (
            <button
              type="button"
              className="flex items-center border-t p-2 mt-2 text-blue-500 "
              onClick={onAddNew}
            >
              <FontAwesomeIcon icon={faPlusCircle} className="w-4 h-4 mr-2" />
              Add New
            </button>
          )}
        </div>
      )}
    </div>
  );
};
const ProductVariants = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [productCategories, setProductCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({ id: '', name: '' });
  const [selectedCategoryId , setSelectedCategoryId] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [productCategoryId, setProductCategoryId] = useState('');
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [errors, setErrors] = useState({});
  const [rows, setRows] = useState([
  { SNo: 1, variant_id: '', variant_name: '' ,variant_value: ''}
]);
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [selectedProductCategory, setSelectedProductCategory] = useState({ id: '', name: '' });
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [products,setProducts] = useState([]);
  const [selectedProduct,setSelectedProduct] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [name, setName] = useState('');
  const [variantGroupId, setVariantGroupId] = useState(null);
  const { handleGetResponse, handleSaveResponse  } = useCommonResponseHandler();
    
    const handleInputChange = (index, field, value) => {
      const updatedRows = [...rows];
      updatedRows[index][field] = value;
      setRows(updatedRows);
    };
  
const addRow = () => {
  if (!selectedProduct) return;

  setRows([
    ...rows,
    {
      SNo: rows.length + 1,
      variant_id: '',
      variant_name: '',
      variant_value: '',
    },
  ]);
};

    const deleteRow = (index ,row) => {
      if(row?.product_id && row?.product_name){
        handleDeleteVariant(index, row)
        
      }else{
        const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
        setRows(updatedRows);
      }
     
    };

    const handleDeleteVariant = async (index, row,attempt = 1) => {
      try {
            const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

        const response = await fetch(`${fetchUrl}product-attributes/delete-attribute-value?attribute_value_id=${row.attribute_value_id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        });
    
        const output = await handleDeleteResponse(response);
        if (output) {
          const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
          setRows(updatedRows);
        }
    
      } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleDeleteVariant(index, row,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleDeleteVariant(index, row,attempt)); // Set retry function
      }
    }
    }
    
    const handleDeleteResponse = (response) => {
      if (response.status === 204) {
        // No content, but successful deletion
        setIsSaving(false);
        setPopupMessage('Variant deleted successfully.');
        setPopupType('204');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        return true;
      } else if (response.status === 200 || response.status === 201) {
        setIsSaving(false);
        setPopupMessage('Variant deleted successfully.');
        setPopupType('200or201');
        setShowPopup(true);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
        return true;
      } else {
        response.json().then(data => {
          setIsSaving(false);
          setPopupMessage(data.message || 'An error occurred.');
          setPopupType(`${response.status}`);
          setShowPopup(true);
        });
        return false;
      }
    }
    

    const fetchProductCategories = async (attempt = 1) => {
      try {
            const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

        const response = await fetch(fetchUrl + "product-category/get-all-productCategories", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });         
        const data = await response.json();        
        if (data.status === 200 || data.status === 201 || data.status === 204) {
          // Map data to expected format
          const categories = data.data.map(cat => ({
            product_category_id: cat._id,
            product_category_name: cat.product_category_name
          }));
          setProductCategories(categories);
        } else {
          setIsSaving(false);
          setPopupMessage(data.message);
          setPopupType(`${data.status}`);
          setShowPopup(true);
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
  
        if (attempt < RETRY_LIMIT) {
          setRetryCount(attempt + 1); // Increment retry count
          setTimeout(() => fetchProductCategories(attempt + 1), 1000); // Retry after 1 second
        } else {
          setIsLoading(false);
          setPopupMessage('Internal Server Error. Kindly Retry.');
          setPopupType('500');
          setShowPopup(true);
          setRetryFunction(() => () => fetchProductCategories(attempt)); // Set retry function
        }
      }finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      fetchRoleId();
      fetchProductCategories();
    }, [fetchUrl]);

    useEffect(() => {
    if (!selectedSubCategory) {
        setFilteredProducts(products);
    }
    }, [products, selectedSubCategory]);

    const fetchRoleId = () => {
      const encryptedroleId = sessionStorage.getItem('roleId');
      const sroleId = decryptData(encryptedroleId)
      setRoleId(sroleId);
    };

    const categoriesToDisplay = roleId === 6 
    ? productCategories.filter(category => (category.product_category_name.toLowerCase()) === 'tiles')
    : productCategories;


const handleCategoryChange = async (name, id) => {
  setSelectedCategory({ id, name });
  setSelectedProductCategory({id,name})
  setSelectedSubCategory(null);
  setSelectedProduct(null);
  setRows([{ SNo: 1, variant_id: '', variant_name: '', variant_value: '' }])

  await fetchSubProductCategories(id);
  await fetchProducts(id);
};


const getProductVariants = async (productId, productName) => {
    console.log("get product variants")
  try {
    if (!productId) return;

    if (!selectedProductCategory?.id) {
      console.log('Product category not selected yet');
      setName('');
      setRows([{ SNo: 1, variant_id: '', variant_name: '',variant_value: '', }]);
      return;
    }

    const encryptedToken = sessionStorage.getItem('token');
    if (!encryptedToken) throw new Error('Token missing');

    const token = decryptData(encryptedToken);

    const queryParams = new URLSearchParams({
      product_id: productId,
      product_category_id: selectedProductCategory.id,
    });

    // Only add subcategory if it exists
    if (selectedSubCategory?.id) {
      queryParams.append('product_sub_category_id', selectedSubCategory.id);
    }

    const response = await fetch(
      `${fetchUrl}product/get-product-variants?${queryParams.toString()}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    console.log(response,"response")
    if (response.status === 204) {
      setName('');
      setRows([{ SNo: 1, variant_id: '', variant_name: '',variant_value: '', }]);
      return;
    }

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err?.message || 'Failed to fetch variants');
    }

    const result = await response.json();
    const variantGroup = result?.data?.[0];

    console.log(result)

    if (!variantGroup?.productIds?.length) {
      setName('');
      setRows([{ SNo: 1, variant_id: '', variant_name: '',variant_value: '', }]);
      return;
    }

/*     if (!variantGroup?.variants?.length) {
      setName('');
      setRows([{ SNo: 1, variant_id: '', variant_name: '', variant_value: '' }]);
      return;
    }  */ 

    // ✅ SAVE VARIANT GROUP ID
    setVariantGroupId(variantGroup._id);
    setName(variantGroup.name || '');

/*     const rows = variantGroup.productIds
    .filter(id => String(id) !== String(productId))
    .map((id, index) => {
        const product = products.find(p => String(p._id) === String(id));

        return {
        SNo: index + 1,
        variant_id: id,
        variant_name: product?.product_name || '',
        variant_value: product?.variant_value || '',
        };
    });

    setRows(rows.length ? rows : [{ SNo: 1, variant_id: '', variant_name: '',variant_value: '', }]); */

        const rows = variantGroup.variants
      /* .filter(v => String(v.product_id) !== String(productId)) */
      .map((v, index) => {
        const product = products.find(
          p => String(p._id) === String(v.product_id)
        );

        return {
          SNo: index + 1,
          variant_id: v.product_id,
          variant_name: product?.product_name || '',
          variant_value: v.variant_value || '',
        };
      });

    setRows(rows.length
      ? rows
      : [{ SNo: 1, variant_id: '', variant_name: '', variant_value: '' }]
    );
  } catch (error) {
    console.error('Error fetching product variants:', error.message);
    setVariantGroupId(null);
    setName('');
    setRows([{ SNo: 1, variant_id: '', variant_name: '' ,variant_value: '',}]);
  }
};


  const getResponseHandling = async (response, data)=>{
    if (response.status === 200 || response.status === 201) {
      setPopupType('200or201');
        return (data.data)
    } else if (response.status === 204) {
      setPopupType('204');
      return (data.data)
    } 
 
    if (response.status === 400) {
      setPopupType('400');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else if (response.status === 401) {
      setPopupType('401');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else if (response.status === 403) {
     
      setPopupType('403');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else if (response.status === 404) {
      return null
    } 
     else if (response.status === 500) {
     
      setPopupType('500');
      setPopupMessage(data.message);
      setShowPopup(true);
      return null
    } else {
      setErrorMessages([...errorMessages, data.message]);
    }
  
}

  const fetchProducts = async (categoryId,attempt = 1) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);

      const response = await fetch(`${fetchUrl}product/get-products-by-category?product_category_id=${categoryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });
      const data = await response.json();
      console.log(data);
      const output = await getResponseHandling(response,data)
            if (output) {      
        setProducts(output);
        setRows([{ SNo: 1, variant_id: '', variant_name: '', variant_value: '' }])
        setSelectedProduct('')
        //return products;
      } else {
        setProducts([])
        setSelectedProduct('')
        setRows([{ SNo: 1, variant_id: '', variant_name: '', variant_value: '' }])
        return [];
      }
    }catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchProducts(categoryId,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchProducts(categoryId,attempt)); // Set retry function
      }
    }
  };
  
   const fetchSubProductCategories = async (product_category_id,attempt = 1) => {
     console.log('Fetching subcategories for ID:', product_category_id);
     
     try {
           const encryptedToken = sessionStorage.getItem('token');
               const token = decryptData(encryptedToken);
 
       const response = await fetch(fetchUrl + `product-sub-category/get-productSubCategories-by-productCategoryId?product_category_id=${product_category_id}`, {
         method: 'GET',
         headers: {
           'Content-Type': 'application/json',
           'x-token': token
         }
       });
       const data = await response.json();
       const output = await handleGetResponse(response , data)
        
       console.log('Fetched Data:', data);
       if (output) {
        console.log("output",output)
         setProductSubCategories(output);
       } else {
         /* console.error(data.message); */
       }
     } catch (error) {
       console.error('Failed to fetch:', error);
 
       if (attempt < RETRY_LIMIT) {
         setRetryCount(attempt + 1); // Increment retry count
         setTimeout(() => fetchSubProductCategories(product_category_id,attempt + 1), 1000); // Retry after 1 second
       } else {
         setIsLoading(false);
         setPopupMessage('Internal Server Error. Kindly Retry.');
         setPopupType('500');
         setShowPopup(true);
         setRetryFunction(() => () => fetchSubProductCategories(product_category_id,attempt)); // Set retry function
       }
     }
   };

const handleProductSubcategory = (name, id) => {
  setSelectedSubCategory({ id, name });

  const filtered = products.filter(
    (p) => p.product_sub_category_id === id
  );

  setFilteredProducts(filtered);
};

const handleProductChange = async (name, id) => {
    console.log(name,id,"in handle product cahnge")
  setSelectedProduct({ id, name });
  await getProductVariants(id, name);
};

 
  const handleRowVariantSelect = (rowIndex, name, id) => {
  const updatedRows = [...rows];
  updatedRows[rowIndex] = {
    ...updatedRows[rowIndex],
    variant_id: id,
    variant_name: name,
  };
  setRows(updatedRows);
};


const handleSaveVariants = async (attempt = 1) => {
  try {
    if (!selectedProduct) {
      setErrors({ product: 'Please select a product' });
      return;
    }

    if (!name.trim()) {
      setErrors({ attribute_name: 'Name is required' });
      return;
    }

    if (!selectedCategory?.id) {
      setErrors({ product_category: 'Item category is required' });
      return;
    }

    console.log(selectedProduct)

    // Include selected product + variants (unique)
    const productIds = Array.from(
      new Set([
        selectedProduct.id,
        ...rows.map(r => r.variant_id).filter(Boolean)
      ])
    );

    if (productIds.length === 0) {
      setErrors({ attribute_value: 'Please select at least one item' });
      return;
    }

// ✅ Build variants array (including selected product)
    const variants = [
      {
        product_id: selectedProduct.id,
        variant_value: selectedProduct?.variant_value || ''
      },
      ...rows
        .filter(r => r.variant_id)
        .map(r => ({
          product_id: r.variant_id,
          variant_value: r.variant_value || ''
        }))
    ];
/*     const variants = rows
      .filter(r => r.variant_id)
      .map(r => ({
        product_id: r.variant_id,
        variant_value: r.variant_value || ''
      })); */

    // ✅ productIds derived from variants
    //const productIds = variants.map(v => v.product_id);

    if (productIds.length === 0) {
      setErrors({ attribute_value: 'Please select at least one item' });
      return;
    }

    const payload = {
      _id: variantGroupId || undefined,
      name: name.trim(),
      product_category_id: selectedCategory.id,
      product_sub_category_id: selectedSubCategory?.id || null,
      productIds,
      variants,
      active: true
    };

    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    setIsSaving(true);

    const response = await fetch(
      `${fetchUrl}product/create-or-update-product-variants`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(payload),
      }
    );

    const Data = await response.json();
    setIsSaving(false);

    if (Data.status === 200 || Data.status === 201) {
      setPopupMessage(Data.message);
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        navigate('/admin/app/items/itemslist');
      }, 3000);
    } else if (Data.status === 204) {
      setPopupMessage(Data.message);
      setPopupType('204');
      setShowPopup(true);
    } else if (Data.status === 409) {
      setErrors({ duplication: Data.message });
    } else {
      setPopupMessage(Data.message || 'Something went wrong');
      setPopupType(`${Data.status}`);
      setShowPopup(true);
    }

  } catch (error) {
    console.error('Failed to save variants:', error);

    if (attempt < RETRY_LIMIT) {
      setTimeout(() => handleSaveVariants(attempt + 1), 1000);
    } else {
      setIsSaving(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleSaveVariants(attempt));
    }
  }
};

const handleCloseError = () => {
  setErrorMessages([]);
};

const closePopup = () => {
  console.log("closePopup called");
  setShowPopup(false);
};

const Retry = async() => {
  console.log("Retry called");
  setTimeout(async ()=>{
    if(retryFunction){

      await retryFunction ();
    }

    setIsLoading(false)
  },1000)
  
  setShowPopup(false);
};

const BackToLoginPage = () => {
  console.log("Back To Login Page");
  setShowPopup(false);
  localStorage.removeItem('LoginData');
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('appId');
navigate('/admin');
};

const handleStayHere = () => {
  setShowCancelPopup(false);
}

const handleCancel = () => {
  setShowCancelPopup(true);
}

const handleLeave = () => {
  navigate(-1);
}

const handleChange = (e) => {
  const { value } = e.target;
  setName(value);
};

if (isLoading) {
  return <Loader />;
}


  return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-bold">Item Variants</h1>
                </div>
              </div>
              {Object.keys(errors).length > 0 && (
        <div className="flex justify-between  w-full p-2 items-center px-auto py-3 bg-[#fddcde] rounded-md">
          <div className="px-6 flex flex-col space-y-2 justify-start items-start">
            {errors.attribute_name && (
              <span className="text-sm">
                • {errors.attribute_name}
              </span>
            )}
            {errors.product_category && (
              <span className="text-sm">
                • {errors.product_category}
              </span>
            )}
            {errors.attribute_value && (
              <span className="text-sm">
                • {errors.attribute_value}
              </span>
            )}

          {errors.duplication && (
              <span className="text-sm">
                • {errors.duplication}
              </span>
            )}
          </div>
          <div className='px-4'>
            <button
              className="text-gray-700 hover:text-red-500"
              onClick={() => setErrors({})}
            >
              <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
            </button>
          </div>
        </div>
      )}
              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">            
                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="categoryname" className="block text-sm font-regular text-[#e54643] w-1/6">Item Category <span className="text-red-500">*</span></label>
                    <CustomDropdown
                      options={categoriesToDisplay}
                      selected={selectedCategory?.name}
                      onSelect={handleCategoryChange}
                      labelField="product_category_name"
                      valueField="product_category_id"
                      placeholder="Select Product Category"
                    />
                  </div>
                </div>

                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="subcategoryname" className="block text-sm font-regular w-1/6">Item Sub Category </label>
                    <CustomDropdown
                      options={productSubCategories}
                      selected={selectedSubCategory?.name}
                      onSelect={handleProductSubcategory}
                      labelField="product_sub_category_name"
                      valueField="product_sub_category_id"
                      placeholder="Select Product Sub Category"
                    />
                  </div>
                </div>

                <div className="w-full flex flex-col justify-start items-start px-4 ">
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="productname" className="block text-sm font-regular text-[#e54643] w-1/6">Item <span className="text-red-500">*</span></label>
                    <CustomDropdown
                      options={filteredProducts.length ? filteredProducts : products}
                      selected={selectedProduct?.name}
                      onSelect={handleProductChange}
                      labelField="product_name"
                      valueField="_id"
                      placeholder="Select Product"
                    />
                  </div>
                </div>

                <div className="w-full flex flex-col justify-start items-start px-4">
                <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="name" className="block text-sm font-regular w-1/6">
                    Name <span className="text-red-500">*</span>
                    </label>
                    <input
                    type="text"
                    id="name"
                    className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    value={name}
                    onChange={handleChange}
                    placeholder="Enter name"
                    />
                </div>
                </div>

                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-md font-semibold">Items</h1>
                  
                </div>

                <div className="w-full container mx-auto px-4 mb-2 mt-4">
                  {rows.length > 0 ? (
                  <table className="w-full">
                    <thead>
                      <tr className="text-[#6c7184] bg-[#fafafc]">
                        <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">SNo</th>
                        <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">Name</th>
                        <th className="font-semibold text-left text-sm py-2 px-2 border">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                    {rows.map((row, index) => (
                            <tr key={index}>
                              <td className="py-2 px-4 border">{index + 1}</td>
                              <td className="border">
                            <CustomDropdown
                            options={filteredProducts.length ? filteredProducts : products}
                            selected={row.variant_name}
                            onSelect={(name, id) => handleRowVariantSelect(index, name, id)}
                            labelField="product_name"
                            valueField="_id"
                            placeholder="Select Variant"
                            />
                              </td>
                              <td className="border px-2">
                              <input
                                type="text"
                                value={row.variant_value}
                                onChange={(e) =>
                                  handleInputChange(index, 'variant_value', e.target.value)
                                }
                                className="w-full outline-none border border-gray-300 rounded-md p-1 text-sm"
                                placeholder="Enter value"
                              />
                            </td>
                              <td className="px-2">
                                <button
                                  type="button"
                                  onClick={() => deleteRow(index ,row)}
                                  className="text-red-500"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  ):(
                    <div className="text-center py-4">
                    <p>No Attributes</p>
                    </div>
                  )}
                </div>

                <div className="mt-4">
                  <button
                    onClick={addRow}
                    className="text-blue-500 py-2 px-4"
                  >
                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                    Add Item
                  </button>
                </div>
                </div>

                <div className="mt-5 w-full">
                <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                  <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                    onClick={handleSaveVariants}                  >
                    <span>Save</span>
                    {isSaving && ( <Spinner/>)}
                  </button>
                  <button onClick={handleCancel}  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}>
          Cancel</button>
                </div>
                </div>   
            </div>
          </div>
        </div>

         {/* Popup starts */}

         {showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  <span>Stay Here</span>
    {isSaving && (<Spinner/>)}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}


{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup}/>}
  </div>
)}
{/* Popup ends */}
      </div>
       
    </div>
  );
};

export default ProductVariants;
